import { connect } from 'react-redux';

import Loader from '@/components/common/Loader';

export default connect(
  state => ({
    loading: state.common.loading,
  }),
  {
    
  }
)(Loader);


// WEBPACK FOOTER //
// ./src/containers/common/LoaderContainer.js